import React, { useState } from "react";
import { Stack } from "@mui/material";
import TabNavigation from "../../ui/TabNavigation";
import { CardWrapper } from "../../ui";
import PreClearTab from "./PreClearTab";
import HistoryTab from "./HistoryTab";
import { TOUCH, focusRing } from "./regmStyles";

const tabs = [
  { value: "preclear", label: "PreClear" },
  { value: "history", label: "History" },
];

// Local to this page: the shared tab buttons are too small to tap and show no keyboard focus.
const tabBarSx = {
  mt: 2,
  "& .MuiButton-root": { minHeight: TOUCH, px: 2, fontSize: "12px", ...focusRing },
};

const RegMPreClear = () => {
  const [activeTab, setActiveTab] = useState("preclear");

  return (
    <Stack spacing={1}>
      <CardWrapper sx={tabBarSx}>
        <TabNavigation
          tabs={tabs}
          activeTab={activeTab}
          onTabChange={setActiveTab}
        />
      </CardWrapper>

      {activeTab === "preclear" && <PreClearTab />}
      {activeTab === "history" && <HistoryTab />}
    </Stack>
  );
};

export default RegMPreClear;
